import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

export const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: COLORS.snow,
  padding: '5px',
  borderRadius: '10px'
});

export const CommentDateText = styled('p')({
  marginTop: '5px',
  textAlign: 'left',
  fontSize: '12px',
  color: COLORS.black,
  fontFamily: FONTS_FAMILY.regular.body
});